"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXInfrastructure = void 0;
const VControllerViewContract_1 = require("./VControllerViewContract");
const ERC20Contract_1 = require("./ERC20Contract");
const VPoolContract_1 = require("./VPoolContract");
const VXStrategyV1Contract_1 = require("./VXStrategyV1Contract");
const VXSManagerV2Contract_1 = require("./VXSManagerV2Contract");
const PriceKeeperContract_1 = require("./PriceKeeperContract");
const VXContract_1 = require("./VXContract");
const App_1 = require("../App");
class VXInfrastructure {
    get vxERC20() { return this._vxERC20; }
    get vx() { return this._vx; }
    get vcontroller() { return this._vcontroller; }
    get vpool() { return this._vpool; }
    get vxstrategyV1() { return this._vxstrategyV1; }
    get vxsManagerV2() { return this._vxsManagerV2; }
    get priceKeeperPLS() { return this._priceKeeperPLS; }
    initializeAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const web3 = App_1.App.chain.web3;
                this._vcontroller = new VControllerViewContract_1.VControllerViewContract(VXInfrastructure.ADDRESS_VController, web3);
                const vxA = this._vcontroller.getVXAddressAsync();
                const vpoolA = this._vcontroller.getVPoolAddressAsync();
                yield Promise.all([vxA, vpoolA]);
                const vx = yield vxA;
                const vpool = yield vpoolA;
                this._vxstrategyV1 = new VXStrategyV1Contract_1.VXStrategyV1Contract(VXInfrastructure.ADDRESS_VXStrategyV1, web3);
                this._vxsManagerV2 = new VXSManagerV2Contract_1.VXSManagerV2Contract(VXInfrastructure.ADDRESS_VXSManagerV2, web3);
                this._vxERC20 = new ERC20Contract_1.ERC20Contract(vx, web3);
                this._vx = new VXContract_1.VXContract(vx, web3);
                this._vpool = new VPoolContract_1.VPoolContract(vpool, web3);
                this._priceKeeperPLS = new PriceKeeperContract_1.PriceKeeperContract(VXInfrastructure.ADDRESS_PriceKeeperPLS, web3);
                App_1.App.chain.addContracts([this._vxERC20, this._vx, this._vcontroller, this._vpool, this._vxstrategyV1, this._vxsManagerV2, this._priceKeeperPLS]);
                return true;
            }
            catch (e) {
                App_1.App.gui.dialogOkShowAsync(e);
            }
            return false;
        });
    }
}
exports.VXInfrastructure = VXInfrastructure;
VXInfrastructure.ADDRESS_VController = "0x16D360ae36851a3B4F6256c15b90C30Cf0fC6B54";
VXInfrastructure.ADDRESS_VXStrategyV1 = "0xa3466257aEe03495C057B94382EEc266B94C89cD";
VXInfrastructure.ADDRESS_VXSManagerV2 = "0xC6641d5B6Cb43045BC38F7c294f42215A0E4072C";
VXInfrastructure.ADDRESS_PulseXRouterV1 = "0x98bf93ebf5c380C0e6Ae8e192A7e2AE08edAcc02";
VXInfrastructure.ADDRESS_PulseXRouterV2 = "0x165C3410fC91EF562C50559f7d2289fEbed552d9";
VXInfrastructure.ADDRESS_PriceKeeperPLS = "0x51e1649422b8ad4E68cBDb2aDDB571038F136c15";
//# sourceMappingURL=VXInfrastructure.js.map